"use strict";

module.exports = {
    "user2": {
        "add-account": "Додати акаунт",
        "edit-accounts": "Редагувати список",
        "enter": "Увійти",
        "exit": "Вийти",
        "help": "Допомога",
        "mail": ["новий лист", "нові листи", "нових листів", "Немає нових листів"],
        "mail_compose": "Написати лист",
        "passport": "Керування акаунтом",
        "settings": "Налаштування",
        "upload_files": "Мій Диск"
    }
};